export const range = (start, stop) =>
	Array(stop - start + 1).fill().map((_,i) => i + start)

// Injected by rollup
export const env = environment
